/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { StaffUserRef } from './StaffUserRef';
import {
    StaffUserRefFromJSON,
    StaffUserRefFromJSONTyped,
    StaffUserRefToJSON,
    StaffUserRefToJSONTyped,
} from './StaffUserRef';
import type { MedicaidCaseStatus } from './MedicaidCaseStatus';
import {
    MedicaidCaseStatusFromJSON,
    MedicaidCaseStatusFromJSONTyped,
    MedicaidCaseStatusToJSON,
    MedicaidCaseStatusToJSONTyped,
} from './MedicaidCaseStatus';

/**
 * 
 * @export
 * @interface MedicaidCase
 */
export interface MedicaidCase {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    status: MedicaidCaseStatus;
    /**
     * 
     */
    owner: StaffUserRef | null;
    /**
     * 
     */
    revision: number;
    /**
     * Calendar date, YYYY-MM-DD
     */
    verification_dob: string | null;
    /**
     * 
     */
    verification_dob_confirmed_at: Date | null;
    /**
     * 
     */
    verification_dob_confirmed_by: StaffUserRef | null;
    /**
     * 
     */
    closed_at: Date | null;
    /**
     * 
     */
    closed_reason: string | null;
    /**
     * 
     */
    created_at: Date;
    /**
     * 
     */
    updated_at: Date;
}



/**
 * Check if a given object implements the MedicaidCase interface.
 */
export function instanceOfMedicaidCase(value: object): value is MedicaidCase {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('revision' in value) || value['revision'] === undefined) return false;
    if (!('verification_dob' in value) || value['verification_dob'] === undefined) return false;
    if (!('verification_dob_confirmed_at' in value) || value['verification_dob_confirmed_at'] === undefined) return false;
    if (!('verification_dob_confirmed_by' in value) || value['verification_dob_confirmed_by'] === undefined) return false;
    if (!('closed_at' in value) || value['closed_at'] === undefined) return false;
    if (!('closed_reason' in value) || value['closed_reason'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    return true;
}

export function MedicaidCaseFromJSON(json: any): MedicaidCase {
    return MedicaidCaseFromJSONTyped(json, false);
}

export function MedicaidCaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicaidCase {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'facility_id': json['facility_id'],
        'status': MedicaidCaseStatusFromJSON(json['status']),
        'owner': StaffUserRefFromJSON(json['owner']),
        'revision': json['revision'],
        'verification_dob': json['verification_dob'],
        'verification_dob_confirmed_at': (json['verification_dob_confirmed_at'] == null ? null : parseDateTime(json['verification_dob_confirmed_at'])),
        'verification_dob_confirmed_by': StaffUserRefFromJSON(json['verification_dob_confirmed_by']),
        'closed_at': (json['closed_at'] == null ? null : parseDateTime(json['closed_at'])),
        'closed_reason': json['closed_reason'],
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'updated_at': (json['updated_at'] == null ? json['updated_at'] : parseDateTime(json['updated_at'])),
    };
}

export function MedicaidCaseToJSON(json: any): MedicaidCase {
    return MedicaidCaseToJSONTyped(json, false);
}

export function MedicaidCaseToJSONTyped(value?: MedicaidCase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'facility_id': value['facility_id'],
        'status': MedicaidCaseStatusToJSON(value['status']),
        'owner': StaffUserRefToJSON(value['owner']),
        'revision': value['revision'],
        'verification_dob': value['verification_dob'],
        'verification_dob_confirmed_at': value['verification_dob_confirmed_at'] == null ? value['verification_dob_confirmed_at'] : serializeDateTime(value['verification_dob_confirmed_at']),
        'verification_dob_confirmed_by': StaffUserRefToJSON(value['verification_dob_confirmed_by']),
        'closed_at': value['closed_at'] == null ? value['closed_at'] : serializeDateTime(value['closed_at']),
        'closed_reason': value['closed_reason'],
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'updated_at': value['updated_at'] == null ? value['updated_at'] : serializeDateTime(value['updated_at']),
    };
}

